import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "my-8 max-w-screen-sm m-2 md:mx-auto border p-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-2 justify-center items-center"
}
const _hoisted_3 = { class: "text-bold font-semibold" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "text-bold text-center font-semibold" }

import CButton from "@/components/Button.vue";
import { useI18n } from "vue-i18n";
import { useNotify } from "@/composables/useNotify";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmBooking',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const { errorToast } = useNotify({ t });
const store = useStore();
const showError = () => {
  errorToast({
    title: t("reservation"),
    error: "ONLINE_BOOKING_ERROR",
  });
};
const step = ref(0);
const isLoading = ref(false);
const confirmBooking = async () => {
  try {
    isLoading.value = true;
    await store.dispatch("reservation/CONFIRM_BOOKING", {
      id: router.currentRoute.value.params.id,
    });
    step.value = 1;
  } catch (e) {
    showError();
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (step.value === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("youAreWillingToConfirmBooking")), 1),
          _createVNode(CButton, {
            class: _normalizeClass(["p-button-xs p-button-success", { 'pointer-events-none': isLoading.value }]),
            onClick: confirmBooking
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("iConfirm")) + " ", 1),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "..."))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"])
        ]))
      : _createCommentVNode("", true),
    (step.value === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("thankYou")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})